import { Button, Checkbox, Form, Input, message, Layout, Space } from 'antd';
import { auth } from './base'
import { signInWithEmailAndPassword, onAuthStateChanged, signOut } from "firebase/auth";
import { useEffect, useState } from 'react';

const { Header, Footer, Sider, Content } = Layout;

const LoginPage = () => {
  const [messageApi, contextHolder] = message.useMessage();
  const [loading, setLoading] = useState(false)

  const onFinish = (values) => {
    setLoading(true)
    signInWithEmailAndPassword(auth, values.username, values.password)
      .then((userCredential) => {
        // Signed in 
        messageApi.open({
          type: 'success',
          content: 'logged in',
        });
      })
      .catch((error) => {
        setLoading(false);
        const readableErrors = {
          'auth/wrong-password': {
            'text': 'Email o Password sbagliata'
          },
          'auth/too-many-requests': {
            'text': 'Troppe richieste, riprova più tardi'
          },
          'auth/user-not-found': {
            'text': 'Utente non trovato'
          }
        }

        function errorMessage(value) {

          if (value in readableErrors) {
            return readableErrors[value].text
          } else {
            return 'error: ' + value
          }
        }


        messageApi.open({
          type: 'error',
          content: errorMessage(error.code),
        });
      });

  };
  return (
    <div className='absolute-center login-w'>
      <Form
        layout='vertical'
        onFinish={onFinish}
        autoComplete="off"
      >
        {contextHolder}
        <Form.Item
          label="Username"
          name="username"

          rules={[
            {
              required: true,
              message: 'Please input your username!',
            },
          ]}
        >
          <Input size='large' />
        </Form.Item>

        <Form.Item
          label="Password"
          name="password"
          rules={[
            {
              required: true,
              message: 'Please input your password!',
            },
          ]}
        >
          <Input.Password size='large' />
        </Form.Item>
        <div style={{ textAlign: 'center' }}>
          <Form.Item
          >
            <Button disabled={loading} style={{ width: '100%', marginTop: 20 }} type="primary" htmlType="submit" size='large'>
              Accedi
            </Button>
          </Form.Item>
        </div>
      </Form>
    </div>
  )
};
export default LoginPage;